// src/utils/theme.js
const themes = {
    default: {
        '--primary-color': '#055A95',
        '--font-color': '#ffffff',
        '--hover-color': '#077CCD',
        '--badge-color': '#077ccd',
        '--bg-color': '#f2f8fe',
      },
    green: {
      '--primary-color': '#6fa64e',
      '--font-color': '#ffffff',
      '--hover-color': '#8fc578',
      '--badge-color': '#f79235',
      '--bg-color': '#EFF5EC',
    },
       red: {
      '--primary-color': '#c13350',
      '--font-color': '#ffffff',
      '--hover-color': '#d98092',
      '--badge-color': '#a00020',
      '--bg-color': '#f7e6e9',
    },
       purple: {
      '--primary-color': '#853990',
      '--font-color': '#ffffff',
      '--hover-color': '#94529e',
      '--badge-color': '#660874',
      '--bg-color': '#e0cee3',
    }
  };
  
  export function setTheme(themeName) {
    const theme = themes[themeName];
    if(theme!=null){
        Object.keys(theme).forEach(key => {
            document.documentElement.style.setProperty(key, theme[key]);
          });
    }
 
  }